var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popup",on:{"click":function($event){if($event.target !== $event.currentTarget)return null;return _vm.$emit('close')}}},[_c('base-card',{staticClass:"card"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }